import { useState } from 'react';

// CSS
import '_Asset/css/User/Page/support.css'

// Component
import axios from 'axios';

// API
import { SupportReqApi, SupportCatApi } from '_Route/Api';
import { useEffect } from 'react';


const DevSupport = () => {

  const [successCheck, setSuccessCheck] = useState(true); // 입력값 체크 boolean값
  const [serviceList, setServiceList] = useState([]); // service 리스트
  const [emailCheck, setEmailCheck] = useState('');

  const [info, setInfo] = useState({ // 임시 추가
    request_cat: '',
    request_company: '',
    request_name: '',
    request_user_email: '',
    request_email: '',
    request_title: '',
    request_content: '',
    file: undefined,
  })
  const { request_cat, request_company, request_name, request_user_email, request_email, request_title, request_content, file } = info;
  

  // onChange Function
  const onChange = (e) => {
    const { name, value } = e.target;
    setInfo({...info, [name]: value});

    if (name === 'request_user_email') {
      checkEmail(value)
    }
  }

  // Upload File
  const onUploadFile = (file) => {

    if(file) {
      const fileSize = file.size; // 업로드한 파일 용량
      const maxSize = 3 * 1024 * 1024 // 3MB
      
      if(fileSize > maxSize) {
        alert("첨부파일은 최대 3MB 까지만 등록이 가능합니다.");
        return false
      } else {
        setInfo({...info, file: file});
        return true
      }
    }
  }

  const checkEmail = (value) => {
    const regExp = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
    setEmailCheck(regExp.test(value));
  }

  // GET Service List
  useEffect(() => {
    axios.get(SupportCatApi)
    .then(res => {
      // console.log(res, "res")
      setServiceList(res.data.result)
    })
    .catch(err => {
      console.error(err, "err")
    })
  }, [])

  // 선택된 Service 이메일 삽입 
  useEffect(() => {
    setInfo({...info, request_email: serviceList[request_cat]?.reqcat_email})
  }, [request_cat])
  

  const sendSupport = () => {

    const formData = new FormData;
    const infoValArr = Object.values(info);
    const sendCheck = !infoValArr.includes('');

    Object.entries(info).map(ent => {
      formData.append(ent[0], ent[1]) /* key, value*/
    })

    if (sendCheck && emailCheck) {
      axios({
        method: 'POST',
        url: SupportReqApi,
        data: formData
      })
      .then(res => {
        // console.log(res, 'SUCCESS')
        
        alert('문의 전송이 완료되었습니다.')
        setInfo({
          request_cat: '',
          request_company: '',
          request_name: '',
          request_user_email: '',
          request_email: '',
          request_title: '',
          request_content: '',
          file: undefined,
        })
      })
      .catch(err => {
        console.error(err, 'ERROR..')
      })
      setSuccessCheck(true)
    } else {
      setSuccessCheck(false)
    }
  }
  
  
  return (
    <>
      {/* Visual */}
      <div className="visual support">
        <div className="section">
          <div className="visualTitGroup">
            <h2 className="visualTit">Support Request</h2>
            
            <p className="visualTxt">The developer support team provides technical support for the Seyfert system.</p>
          </div>
        </div>
      </div>

      <div className="mainContents">
        <div className="section">
          <div className="supportArea areaBox">
            <fieldset>
              <legend>Support Request Form</legend>

              {/* 서비스 선택 Field */}
              <div className="fieldGroup">
                <label htmlFor="">서비스 선택<span className="redTxt">*</span></label>
                
                <div className="field">
                  <select className="type_1 lg select round_10" value={request_cat} name="request_cat" onChange={(e) => onChange(e)}>
                    <option value="">선택</option>
                    {serviceList.map((list, i) => 
                      <option key={i} value={list.reqcat_no}>{list.request_cat}</option>
                    )}
                  </select>
                </div>
                {
                  !successCheck && request_cat === '' &&
                  <p className="fieldTxt error"><i className="icofont-warning-alt"></i>카테고리를 선택해 주세요.</p>
                }
              </div>

              {/* 회사명, 이름 Field */}
              <div className="fieldWrap">
                <div className="fieldGroup">
                  <label htmlFor="">회사명<span className="redTxt">*</span></label>
                  
                  <div className="field">
                    <input type="text" name="request_company" className="input lg round_10" value={request_company} onChange={(e) => onChange(e)} placeholder="회사명을 입력해주세요."></input>
                  </div>
                  {
                    !successCheck && request_company === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>회사명을 입력해 주세요.</p>
                  }
                </div>

                <div className="fieldGroup">
                  <label htmlFor="">이름<span className="redTxt">*</span></label>
                  
                  <div className="field">
                    <input type="text" name="request_name" className="input lg round_10" value={request_name} onChange={(e) => onChange(e)} placeholder="이름을 입력해주세요."></input>
                  </div>
                  {
                    !successCheck && request_name === '' &&
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>이름을 입력해주세요.</p>
                  }
                </div>
              </div>

              {/* 이메일 Field */}
              <div className="fieldGroup">
                <label htmlFor="">이메일<span className="redTxt">*</span></label>
                
                <div className="field">
                  <input type="email" name="request_user_email" className="input lg round_10" value={request_user_email} onChange={(e) => onChange(e)} placeholder="이메일을 입력해주세요."></input>
                </div>
                {
                  !successCheck &&
                  request_user_email === '' ?
                    <p className="fieldTxt error"><i className="icofont-warning-alt"></i>이메일을 입력해주세요.</p>
                  :
                  !successCheck && !emailCheck &&
                  <p className="fieldTxt error"><i className="icofont-warning-alt"></i>올바른 형식의 이메일을 입력해주세요.</p>
                }
              </div>

              {/* 제목 Field */}
              <div className="fieldGroup">
                <label htmlFor="">제목<span className="redTxt">*</span></label>
                
                <div className="field">
                  <input type="text" name="request_title" className="input lg round_10" value={request_title} onChange={(e) => onChange(e)} placeholder="제목을 입력해주세요."></input>
                </div>
                {
                  !successCheck && request_title === '' &&
                  <p className="fieldTxt error"><i className="icofont-warning-alt"></i>제목을 입력해주세요.</p>
                }
              </div>

              {/* 내용 Field */}
              <div className="fieldGroup">
                <label htmlFor="">내용<span className="redTxt">*</span></label>
                
                <div className="field">
                  <textarea className="textarea round" name="request_content" value={request_content} onChange={(e) => onChange(e)} placeholder="문의사항에 대한 자세한 내용을 입력해주세요."></textarea>
                </div>
                {
                  !successCheck && request_content === '' &&
                  <p className="fieldTxt error"><i className="icofont-warning-alt"></i>내용을 입력해주세요.</p>
                }
              </div>

              {/* 첨부 파일 Field */}
              <div className="fieldGroup file">
                <label htmlFor="">
                  <p>첨부 파일 (선택)</p>
                  <span>첨부 파일은 최대 3MB까지 등록 가능합니다.</span>
                </label>
                
                <div className="field">
                  <label className={`input file lg type_1 round_10 ${file ? 'active' : ''}`} htmlFor="inputFile">
                    <button type="button" className="btn xs sfrtBlue round_10">파일선택</button>
                    {file ? file.name : '업로드할 파일을 선택해주세요.'}
                  </label>
                  <input type="file" name="file" id="inputFile" className="file" onChange={(e) => onUploadFile(e.target.files[0])}></input>
                </div>
              </div>
            </fieldset>
            
            <div className="btnArea">
              <button type="button" className="btn md sfrtBlue round_10" onClick={sendSupport}>보내기</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DevSupport;